import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AOS from "aos";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "aos/dist/aos.css";

import $ from "jquery";
import Popper from "@popperjs/core";
import "bootstrap/dist/js/bootstrap.bundle.min";


import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/global.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);


AOS.init();